import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from './customersApi';

export interface PublicSettings {
  mercadopagoEnabled: boolean;
}

export const settingsApi = createApi({
  reducerPath: 'settingsApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (build) => ({
    getPublicSettings: build.query<PublicSettings, void>({
      query: () => '/api/v1/settings/public',
      transformResponse: (r: { data: PublicSettings }) => r.data,
    }),
  }),
});

export const { useGetPublicSettingsQuery } = settingsApi;
